<div class="modal">
  <div class="modal-content">
    <div class="headerModal">
      <h3>{{'stats.graphs.names.navDetails'|translate}}</h3>
      <span class="close pointer" style="padding-left: 2em;" (click)="doClose()">
        <i aria-hidden="true" class="fad fa-times fa-1x5 primaryRed close-txt"></i>
      </span>
    </div>
    <div>
      <div class="text-container">
        <span *ngFor="let line of text.split('\n')">{{line}}</span>
      </div>
      <div class="center">
        <button (click)="doClose()">{{'activlist.fermer'|translate}}</button>
      </div>
    </div>
  </div>
</div>
